module.exports = __webpack_public_path__ + "img/desktop-monitor-settings.0e37782c.svg";